// src/components/SubNavigationBar.js
import React from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const SubNavigationBar = ({ 
  subcategories, 
  currentDepartmentPath,
  currentDepartmentName,
  topOffset = '0px',
  variant = 'desktop'
}) => {
  const theme = useTheme();
  const location = useLocation();

  if (!subcategories || subcategories.length === 0) {
    return null;
  }

  const departmentBasePath = `/department/${currentDepartmentPath}`;
  const isMobile = variant === 'mobile';

  return (
    <Box
      sx={{
        position: 'sticky',
        top: topOffset,
        zIndex: theme.zIndex.appBar ? theme.zIndex.appBar - 1 : 1099,
        backgroundColor: 'background.paper',
        borderBottom: `1px solid ${theme.palette.divider}`,
        width: '100%',
        overflowX: 'auto',
        // Hide scrollbar for all browsers
        scrollbarWidth: 'none',  // Firefox
        '&::-webkit-scrollbar': {
          display: 'none', // Chrome, Safari, Edge
        },
        msOverflowStyle: 'none', // IE and Edge
        // Mobile-specific styles
        ...(isMobile && {
          position: 'static',
          borderBottom: 'none',
          backgroundColor: '#f8f9fa',
          px: 1,
          py: 0.5,
          overflowX: 'auto',
          whiteSpace: 'nowrap',
        })
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: isMobile ? 'flex-start' : 'center',
          alignItems: 'center',
          py: isMobile ? 0.5 : theme.spacing(0.75),
          px: { xs: 1, sm: 2, md: 3 },
          gap: isMobile ? 1 : { xs: 1.5, sm: 2 },
          whiteSpace: 'nowrap',
          minWidth: 'fit-content',
          flexDirection: 'row-reverse',
        }}
      >
        {subcategories.map((subcategory) => {
          const subCategoryPath = `${departmentBasePath}/${encodeURIComponent(subcategory.name)}`;
          const isActive = location.pathname === subCategoryPath;
          
          return (
            <Button
              key={subcategory.id}
              component={RouterLink}
              to={subCategoryPath}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              sx={{
                color: isActive ? theme.palette.primary.main : 'text.primary',
                fontWeight: isActive ? 'bold' : 'normal',
                textTransform: 'none',
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                minWidth: 'auto',
                px: isMobile ? 1 : 1.5,
                borderRadius: '5px',
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                  color: theme.palette.primary.dark,
                },
                // Mobile-specific button styles
                ...(isMobile && {
                  color: '#a72c2a',
                  border: '1px solid #a72c2a',
                  backgroundColor: 'white',
                  '&:hover': {
                    backgroundColor: '#a72c2a',
                    color: 'white',
                  },
                })
              }}
            >
              {subcategory.name}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
};

export default SubNavigationBar;